<template>
	<div>
		<div class="integral_info">
			<div class="order_info flex align-center justify-between">
				<div class="left flex align-center">
					<img class="icon" src="../../../assets/images/icon/phone.png" alt="">
					<div class="sn">Order Number：{{detail.order_sn}}</div>
				</div>
				<div class="btn_list flex align-center" v-if="detail.order_status == 0">
					<div class="btn cancel" @click="cancelOrder">Cancel</div>
					<div class="btn" @click="pay">Proceed</div>
				</div>
			</div>
			<div class="user_info flex align-center justify-between" >
				<div class="left flex align-center">
					<div class="name">Name:{{userInfo.first_name}} {{userInfo.last_name}}</div>
					<div class="time">Order time:{{detail.createtime}}</div>
				</div>
				<div class="right flex align-center">
					<div class="item">
						<div class="name">Status:</div>
						<div class="val">{{detail.order_status_txt}}</div>
					</div>
					<div class="item">
						<div class="name">Amount</div>
						<div class="val price">£{{detail.pay_price}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="intetral_table">
			<div class="title">Booking details</div>
			<el-table
			    :data="detail.products"
			    style="width: 100%">
			  
			    <el-table-column
			      prop="name"
			      label="Class">
			    </el-table-column>
				<el-table-column
				  prop="start_date"
				  label="Class Date">
				</el-table-column>
				<el-table-column
				  prop="course_shop_name"
				  label="Venue">
				</el-table-column>
				<el-table-column
				  prop="course_age_name"
				  label="Age group">
				</el-table-column>
				<el-table-column
				  prop="start_time"
				  label="Class Time">
				  <template slot-scope="scope">
				  	<span>{{scope.row.start_time}}-{{scope.row.end_time}}</span>
				  </template>
				</el-table-column>
				<el-table-column
				  label="Child Name">
					<template slot-scope="scope">
						<span>{{scope.row.child.child_first_name}} {{scope.row.child.child_last_name}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column
				  prop="date"
				  width="80"
				  label="操作">
				  <template slot-scope="scope">
					 <div class="detail" @click="getCourse(scope.row)">改课</div>
					</template>
				</el-table-column> -->
			  </el-table>
		</div>
		<div class="model" v-if="showModel" @click="showModel = false">
			<div class="model_content" @click.stop="">
				<div class="title">原课程：{{changeCourseName}}</div>
				<div class="calendar_main">
					<div class="select_list flex align-center">
						<div class="name">*可改课程:</div>
						<div class="search">
							<input type="text" placeholder="请输入">
							<img src="../../../assets/images/icon/search.png" alt="">
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="course_age_id" placeholder="for any age" size="small"  @change="getCourseList">
							   <el-option
							     v-for="item in ageList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="timeStatus"  placeholder="Any time" size="small"  @change="changeTime">
							   <el-option
							     v-for="item in timeOptions"
							     :key="item.value"
							     :label="item.label"
							     :value="item.value">
							   </el-option>
							</el-select>
							
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="course_shop_id" placeholder="Any Venue" size="small"  @change="getCourseList">
							   <el-option
							     v-for="item in shopList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="course_type_id" placeholder="Any class" size="small"  @change="getCourseList">
							   <el-option
							     v-for="item in classifyList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="selectWeek" placeholder="Any class" size="small"  @change="changeWeek">
							   <el-option
							     v-for="item in selectWeekList"
							     :key="item.id"
							     :label="item.label"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
					</div>
					<div class="calendar_header flex align-center justify-between">
						<div class="left flex align-center" @click="lastMonth">
							<img src="../../../assets/images/icon/left.png" alt="">
							<span>Last week</span>
						</div>
						<div class="date">{{showTime1}}-{{showTime2}}</div>
						<div class="right flex align-center" @click="nextMonth">
							<span>Next week</span>
							<img src="../../../assets/images/icon/right.png" alt="">
						</div>
					</div>
					<div class="weeklist">
						<ul class="weekName flex align-center justify-between">
							<li class="item" v-for="(item,index) in weekList" :key="index">
								<span>{{item}}</span>
								<span class="day">{{weekDayList[index]}}</span>
							</li>
						</ul>
						<div class="course_list flex align-center justify-between">
							<div class="day_item" v-for="(item,index) in courseList" :key="index">
								<div>
									<div class="item" v-for="(ite,ind) in item.course" :key="ind" >
										<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
										<div class="place">{{ite.course_shop_name}}</div>
										<div class="info" :style="{'background':ite.color}">
											<div class="name">{{ite.course_type_name}} </div>
											<div class="age">（{{ite.course_age_name}}）</div>
										</div>
										<div class="tag" v-if="num == 0">waiting list</div>
										<!-- <div class="tag_list flex align-center" v-else-if="ite.is_try == 1">
											<div class="tag" @click="openIntro(ite.id)">试课</div>
											<div class="tag" @click="ensureOrder(ite.course_id)">立即订课</div>
										</div> -->
										<div class="tag" v-else>改课</div>
									</div>
									
								</div>
							</div>
						</div>
						
					</div>
					<div class="send flex align-center justify-center">
						<img v-if="selectSend" src="../../../assets/images/icon/select_active.png" alt="">
						<img v-else src="../../../assets/images/icon/select.png" alt="">
						<div>发送邮件通知</div>
					</div>
					<div class="submit_btn">确认</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				order_sn:'',
				weekList:['Mo','Tu','We','Th','Fr','Sa','Su'],
				showModel:false,
				selectSend:false,
				type:0,
				detail:{},
				// 日历
				classifyList:[],
				shopList:[],
				ageList:[],
				course_age_id:'',
				course_shop_id:'',
				course_type_id:'',
				start_time:'',
				start_time1:'',
				end_time1:'',
				end_time:'',
				showTime1:'',
				showTime2:'',
				end_date:'',
				start_date:'',       
				weekStartDay:'',     //一周开始事件
				weekDayList:[],     //每周日期列表
				courseList:[],     //日历课程列表
				timeStatus:'',
				timeOptions:[{
					value:0,
					label:'AM'
				},{
					value:1,
					label:'PM'
				}],
				selectWeekList:[{id:0,label:'Mo'},{id:1,label:'Tu'},{id:2,label:'We'},{id:3,label:'Th'},{id:4,label:'Fr'},{id:5,label:'Sa'},{id:5,label:'Su'}],
				selectWeek:'',
				select_date:'',
				changeCourseName:'',
				changeCourseId:'',
				userInfo:{}
			}
		},
		created(){
			this.order_sn = this.$route.query.order_sn;
			this.getDetail();
			this.getClassify();
			this.getShopList();
			this.getAgeList();
			this.getUser()
		},
		methods:{
			getUser(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
			pay(){
				this.$api.post('pay/stripe',{order_sn:this.order_sn,type:'pc'},res=>{
					if(res.code == 1){
						location.href=res.data.url
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			// 取消订单
			cancelOrder(){
				this.$api.post('course_order/cancelOrder',{order_sn:this.order_sn},res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Succesfully'
						})
						this.getDetail()
					}
				})
			},
			getCourse(item){
				console.log(item)
				this.changeCourseName = item.name;
				this.changeCourseId = item.id;
				this.showModel = true;
				this.getWeek(new Date());
				
			},
			getDetail(){
				this.$api.post('course_order/getOrderDetails',{order_sn:this.order_sn},res=>{
					if(res.code == 1){
						res.data.products.forEach((item,index)=>{
							item.start_time = item.start_time.substring(0,5)
							item.end_time = item.end_time.substring(0,5);
						})
						res.data.order_status_txt = res.data.order_status == 0 ? 'Payment outstanding' : res.data.order_status == 1 ? 'Paid' : 'Cancelled'
						this.detail = res.data;
					}
				})
			},
			changeTime(e){
				console.log(e)
				if(this.timeStatus == 0){
					this.start_time = '00:00';
					this.end_time = '12:00'
				}else{
					this.start_time = '12:00';
					this.end_time = '24:00'
				}
				this.getCourseList()
			},
			changeWeek(e){
				var start = this.start_date.substring(this.start_date.length-2)
				if(this.weekDayList[e] > start){
					this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[e]
				}else{
					this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[e]
				}
				this.getCourseList()
			},
			getWeek(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.weekDayList = weekList;
				this.showTime1 = day1+'/'+month1+'/'+year1;
				this.showTime2 = day2+'/'+month2+'/'+year2;
				this.start_date = year1+'-'+month1+'-'+day1;
				this.end_date = year2+'-'+month2+'-'+day2;
				this.getCourseList()
			},
			lastMonth(){
				var date = new Date(this.start_date).getTime();
				date = date - 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			nextMonth(){
				var date = new Date(this.end_date).getTime();
				date = date + 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			getCourseList(){
				var params = {
					start_date:this.start_date,
					end_date:this.end_date,
					start_time:this.start_time,
					end_time:this.end_time,
					course_age_id:this.course_age_id,
					course_type_id:this.course_type_id,
					course_shop_id:this.course_shop_id,
					course_products_id:this.changeCourseId,
					date:this.select_date
				}
				this.$api.post('Course/getChangeList',params,res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.courseList = res.data;
					}
				})
			},
			getClassify(){
				this.$api.post('Course/getCourseType',{},res=>{
					if(res.code == 1){
						this.classifyList = res.data;
					}
				})
			},
			getShopList(){
				this.$api.post('Course/getCourseShop',{},res=>{
					if(res.code == 1){
						this.shopList = res.data;
					}
				})
			},
			getAgeList(){
				this.$api.post('Course/getCourseAge',{},res=>{
					if(res.code == 1){
						this.ageList = res.data;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.integral_info{
		width: 1240px;
		height: 244px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.6000);
		border-radius: 10px;
		margin-top: 20px;
		margin-left: 20px;
		padding: 40px 40px 0 30px;
		.order_info{
			img{
				width: 39px;
				height: 41px;
				margin-top: 6px;
			}
			.sn{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-left: 15px;
			}
			.btn_list{
				.btn{
					width: 181px;
					height: 57px;
					background: #5C707A;
					border-radius: 29px;
					line-height: 57px;
					text-align: center;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F2EDE6;
					text-align: center;
					margin-left: 20px;
					cursor: pointer;
				}
				.cancel{
					border: 2px solid #5C707A;
					color: #5C707A;
					background: #F7F2EB;
				}
			}
		}
		.user_info{
			padding-left: 55px;
			margin-top: 20px;
			.name{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-right: 70px;
			}
			.time{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
			}
			.item{
				margin-left: 70px; 
				
				.name{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
				}
				.val{
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					margin-top: 20px;
				}
				.price{
					text-align: center;
					color: #C98B2C;
				}
			}
		}
	}
	.intetral_table{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		padding-bottom: 200px;
		margin-left: 20px;
		margin-top: 20px;
		.title{
			
			height: 80px;
			padding-left: 30px;
			line-height: 80px;
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #000000;
		}
		::v-deep .el-table__header tr{
			height: 80px;
			background-color: #5C707A;
		}
		::v-deep .el-table th.el-table__cell{
			background-color: #5C707A;
		}
		::v-deep .el-table tr{
			background-color: #F7F2EB;
			padding-left: 70px;
			height: 80px;
		}
		::v-deep .el-table tr .detial{
			cursor: pointer;
		}
		::v-deep .el-table td:first-child{
			padding-left: 70px;
		}
		::v-deep .el-table th:first-child{
			padding-left: 70px;
		}
		::v-deep .el-table__row{
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			
		}
		::v-deep .el-table__row td{
			border-bottom: 1px solid #5C707A;
		}
		::v-deep .el-table__row .detail{
			color: #5C707A;
			cursor: pointer;;
		}
		::v-deep .el-table thead{
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #F7F2EB;
		}
		::v-deep .el-table tbody .el-table__row:hover>td {
		    background-color: transparent !important;
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
		background-color: rgba(0,0,0,0.3);
		.model_content{
			width: 1240px;
			height: 600px;
			overflow-y: scroll;
			background: #5C707A;
			box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
			border-radius: 10px;
			padding: 30px 20px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			.title{
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
			}
			
			.calendar_main{
				width: 1200px;
				margin: 0 auto;
				padding-top: 40px;
				.select_list{
					.name{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #F7F2EB;
						margin-right:50px;
						flex-shrink: 0;
					}
					.search{
						width: 208px;
						height: 50px;
						background: #FFFFFF;
						border: 1px solid #5C707A;
						border-radius: 25px;
						position: relative;
						flex-shrink: 0;
						input{
							width: 100%;
							height: 100%;
							font-size: 20px;
							font-family: Source Han Sans CN;
							font-weight: 200;
							color: #5C707A;
							line-height: 50px;
							padding: 0 50px 0 20px;
						}
						img{
							width: 25px;
							height: 25px;
							position: absolute;
							top: 50%;
							right: 10px;
							transform: translateY(-50%);
						}
					}
					.item{
						// padding: 0 10px;
						height: 50px;
						background: #FFFFFF;
						border-radius: 10px;
						margin-left: 20px;
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						img{
							width: 27px;
							height: 15px;
							margin-left: 10px;
						}
					}
				}
				::v-deep .el-select{
					// width: 100%;
					height: 100%;
				}
				::v-deep .el-input.el-input--suffix{
					height: 100%;
				}
				::v-deep .el-input__icon{
					line-height: 56px;
				}
				::v-deep .el-input--suffix .el-input__inner{
					height: 100%;
					font-size: 18px;
					background-color: #F7F2EB;
					border: none;
					color: #282E30;
				}
				::v-deep .el-time-spinner__item{
					text-align: center;
				}
				::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
					width: 150px;
				}
				:v-deep .model .model_content .calendar_main[data-v-13306470] .el-input--suffix .el-input__inner{
					width: 150px;
				}
				.calendar_header{
					margin-top: 30px;
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #FFFFFF;
					cursor: pointer;
					img{
						width: 25px;
						height: 26px;
					}
					.left{
						span{
							margin-left: 10px;
						}
					}
					.right{
						span{
							margin-right: 10px;
						}
					}
				}
				.weeklist{
					margin-top: 30px;
					.weekName{
						.item{
							width: 150px;
							height: 60px;
							border: 1px solid #FFFFFF;
							border-radius: 10px;
							padding-left: 60px;
							font-size: 24px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #FFFFFF;
							line-height: 60px;
							.day{
								margin-left: 15px;
							}
						}
					}
					.course_list{
						margin-top: 20px;
						.day_item{
							width: 150px;
							.item{
								width: 100%;
								height: 168px;
								padding-top: 5px;
								background: #FFFFFF;
								font-size: 16px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #282E30;
								line-height: 30px;
								text-align: center;
								.time{
									text-align: center;
								}
								.place{
									text-align: center;
								}
								.info{
									height: 60px;
									background: #C98B2C;
									line-height: 26px;
									text-align: center;
									.name{
										text-align: center;
									}
									.age{
										text-align: center;
									}
									&.red{
										background: #BF5F49;
									}
								}
								.tag{
									width: 70px;
									height: 26px;
									border: 1px solid #000000;
									border-radius: 13px;
									font-size: 12px;
									font-family: Source Han Sans CN;
									font-weight: 400;
									color: #000000;
									text-align: center;
									line-height: 26px;
									margin: 7px auto 0;
									cursor: pointer;
								}
							}
						}
					}
					
				}
				.send{
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #CCCCCC;
					margin-top: 100px;
					img{
						width: 16px;
						height: 16px;
						margin-right:10px;
					}
				}
				.submit_btn{
					width: 182px;
					height: 58px;
					background: #F7F2EB;
					border-radius: 29px;
					line-height: 58px;
					text-align: center;
					font-size: 24px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #5C707A;
					margin: 20px auto;
				}
			}
		}
	}
</style>